import { MapfreCardComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { MapfreAlertComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-alert/mapfre-alert.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { AcmicService, AlertService } from '@mapfre-design-library/src/public_api';
import { ActivatedRoute, NavigationEnd, Router , RouterModule  } from '@angular/router';
import { filter } from 'rxjs/operators';
import { FooterPositionService } from '@services/footer-position-service/footer-position.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreAlertComponent, MapfreCardComponent],
  selector: 'app-billing-main',
  templateUrl: './billing-main.component.html',
})
export class BillingMainComponent implements OnInit {
  invalidRouting: boolean;
  isAcmic = false;
  defaultClasses: string;
  dropdownOpen:boolean;

  constructor(
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService,
    private acmicService: AcmicService,
    private router: Router,
    private footerPositon:FooterPositionService
  ) {
    this.defaultClasses = 'billing details';
    this.onRouteChange();
  }
  onRouteChange() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        if (event['url'].endsWith('/billing/upload-files')) {
          this.defaultClasses = 'billing details upload-files-main-sec';
        } else {
          this.defaultClasses = 'billing details';
        }
      })
  }
  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    this.activatedRoute.queryParams.subscribe((queryParams) => {
      if (queryParams['invalidRouting'] == 'Y') {
        this.invalidRouting = true;
        this.alertService.error(
          'Please review and enter a valid routing number'
        );
      }
    });
    this.footerPositon.$dropdownOpenState.subscribe((state)=>{
      this.dropdownOpen=state;
    })
  }
}
